<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2">Services</h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'products', 
                                    params:{sector_id: sector_id} }">Services</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

            <form @submit.prevent="addNew" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">        


                <!-- ******* Card ******** -->
                <div class="col-md-12 mb-5">

                    <!-- Card Background -->
                    <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground">Background
                                            <span id="iconToggleBackground" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <label>Background  1200 * 440
                                                <button v-if="row.preview" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview = ''; row.base64Image = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview" 
                                                :src="row.preview" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImageChange">
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <!-- End Card Background -->

                     <!-- Card Accreditations -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabMask" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Mask')"
                                        aria-expanded="false" 
                                        aria-controls="collapseMask" 
                                        data-toggle="collapse"
                                        data-target="#collapseMask">Mask
                                        <span id="iconToggleMask" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMask" 
                                    class="collapse" 
                                    aria-labelledby="TabMask" 
                                    data-parent="#accordion">

                                <div class="col-12 pt-3 row">
                    
                    <div class="col-10 tab-danger">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a href="#tab-english" 
                                                    class="nav-link active show" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="true">English
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a href="#tab-arabic" 
                                                    class="nav-link" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="false">Arabic
                                                </a>
                                            </li>
                                        </ul>
                                        
                                        <div class="tab-content">
                                            <div role="tabpanel" 
                                                class="tab-pane fade active show" 
                                                id="tab-english">

                                                <div class="col-12 row mt-5">
                                                    <div class="form-group col-12">
                                        <label for="input1">Background Title</label>
                                        <editor
                                            id="editor01"
                                            v-model="row.bgTitle"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 200,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                                </div>
                                            </div>

                                            <div role="tabpanel" 
                                                class="tab-pane fade in" 
                                                id="tab-arabic">

                                                <div class="col-12 row mt-5">
                                                    <div class="form-group col-12">
                                        <label for="input1">Background Title</label>
                                        <editor
                                            id="editor01_ar"
                                            v-model="row.bgTitle_ar"
                                            :api-key="editor.api_key"
                                            :init="{
                                                height: 200,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-2 py-3 mt-10">
                                        <label for="input2">Background Color</label>
                                        <input class="form-control"
                                                id="input2"  
                                                type="color" 
                                                style="height: 200px" 
                                                v-model="row.bgColor">
                                    </div>

                                    
                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Writer -->

                    <!-- Card Accreditations -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabContent" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Content')"
                                        aria-expanded="false" 
                                        aria-controls="collapseContent" 
                                        data-toggle="collapse"
                                        data-target="#collapseContent">Content
                                        <span id="iconToggleContent" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseContent" 
                                    class="collapse" 
                                    aria-labelledby="TabContent" 
                                    data-parent="#accordion">

                                <div class="col-12 row pt-3">
                    
                    <div class="col-12 tab-danger">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a href="#tab-english1" 
                                                    class="nav-link active show" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="true">English
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a href="#tab-arabic1" 
                                                    class="nav-link" 
                                                    role="tab" 
                                                    data-toggle="tab" 
                                                    aria-selected="false">Arabic
                                                </a>
                                            </li>
                                        </ul>
                                        
                                        <div class="tab-content">
                                            <div role="tabpanel" 
                                                class="tab-pane fade active show" 
                                                id="tab-english1">

                                                <div class="col-12 row mt-5">

                                                    <!-- Title -->
                                    <div class="form-group col-12">
                                        <label for="input1">Title</label>
                                        <input class="form-control" 
                                                id="input1" 
                                                type="text" 
                                                v-model="row.title" 
                                                @keyup="onTitleChange">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Slug -->
                                    <div class="form-group col-12">
                                        <label for="input2">Slug</label>
                                        <input class="form-control text-lowercase"
                                                id="input2"  
                                                type="text" 
                                                v-model="row.slug" 
                                                @keydown.space.prevent 
                                                @paste="onSlugPaste"
                                                @change="onSlugChange(false)">
                                    </div>
                                    <!-- End Slug -->

                                     <!-- Title -->
                                    <div class="form-group col-6">
                                        <label for="input1_1">Sub Title</label>
                                        <input class="form-control" 
                                                id="input1_1" 
                                                type="text" 
                                                v-model="row.subtitle">
                                    </div>
                                    <!-- End Title -->

                                    <!-- Sort -->
                                    <div class="form-group col-6">
                                        <label for="input3">Sort</label>
                                        <input class="form-control" 
                                                id="input3" 
                                                min="0"
                                                type="number" 
                                                v-model.number="row.sort">
                                    </div>
                                    <!-- End Sort -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <label for="input4">Short Body</label>
                                        <editor
                                            id="input4"
                                            v-model="row.short_body"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->


                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input5" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title1" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input5"
                                            v-model="row.body1"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input6" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title2" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input6"
                                            v-model="row.body2"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input7" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title3" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input7"
                                            v-model="row.body3"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input8" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title4" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input8"
                                            v-model="row.body4"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input9" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title5" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input9"
                                            v-model="row.body5"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                                </div>
                                            </div>

                                            <div role="tabpanel" 
                                                class="tab-pane fade in" 
                                                id="tab-arabic1">

                                                <div class="col-12 row mt-5">

                                                    <!-- Title -->
                                    <div class="form-group col-12">
                                        <label for="input1">Title</label>
                                        <input class="form-control" 
                                                id="input1" 
                                                type="text" 
                                                v-model="row.title_ar">
                                    </div>
                                    <!-- End Title -->


                                     <!-- Title -->
                                    <div class="form-group col-12">
                                        <label for="input1_1">Sub Title</label>
                                        <input class="form-control" 
                                                id="input1_1" 
                                                type="text" 
                                                v-model="row.subtitle_ar">
                                    </div>
                                    <!-- End Title -->


                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <label for="input4">Short Body</label>
                                        <editor
                                            id="input4_ar"
                                            v-model="row.short_body_ar"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->


                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input5" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title1_ar" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input5_ar"
                                            v-model="row.body1_ar"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input6" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title2_ar" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input6_ar"
                                            v-model="row.body2_ar"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input7" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title3_ar" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input7_ar"
                                            v-model="row.body3_ar"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input8" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title4_ar" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input8_ar"
                                            v-model="row.body4_ar"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                    <!-- Body -->
                                    <div class="form-group col-12">
                                        <input for="input9" 
                                            type="text" 
                                            class="form-control" 
                                            v-model="row.title5_ar" 
                                            style="width: 50%;margin-bottom: 10px">
                                        <editor
                                            id="input9_ar"
                                            v-model="row.body5_ar"
                                           :api-key="editor.api_key"
                                            :init="{
                                                height: 300,
                                                menubar: editor.menubar,
                                                plugins: editor.plugins,
                                                toolbar: editor.toolbar
                                            }"
                                        />
                                    </div>
                                    <!-- End Body -->

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    

                           

                                    <div class="col-md-12">
                                    <h4><br/>Status & Visibility</h4>
                                    <div class="col-md-12">

                                    <!-- Status -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch1" 
                                                    :checked="row.status"
                                                    @click="onStatus">
                                                <label class="custom-control-label" 
                                                    for="customSwitch1"
                                                    v-html="(row.status) ? 'Inactive' : 'Active'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Status -->



                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch2" 
                                                    :checked="row.has_application"
                                                    @click="onApplication">
                                                <label class="custom-control-label" 
                                                    for="customSwitch2"
                                                    v-html="(row.has_application) 
                                                        ? 'Hide Application' 
                                                        : 'Show Application'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Training -->

                                        <div class="col-12 row" v-if="row.has_application">
                                            <div class="form-group col-md-3 col-sm-12">
                                                <label>Application Name (en)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.application_name">
                                            </div>
                                            <div class="form-group col-md-3 col-sm-12">
                                                <label>Application Name (ar)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.application_name_ar">
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>Application Type</label>
                                                <select class="form-control" 
                                                    v-model="row.application_path">
                                                    <option value="members-applications">
                                                        Career Application
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <!-- Faq -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch3" 
                                                    :checked="row.has_faq"
                                                    @click="onFaq">
                                                <label class="custom-control-label" 
                                                    for="customSwitch3"
                                                    v-html="(row.has_faq) ? 'Hide FAQ' : 'Show FAQ'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Faq -->


                                        <div class="col-12 row" v-if="row.has_faq">
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>FAQ Link</label>
                                                <input type="text" 
                                                    class="form-control" 
                                                    v-model="row.faq_link">
                                            </div>
                                        </div>


                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch33" 
                                                    :checked="row.has_payment"
                                                    @click="onPayment">
                                                <label class="custom-control-label" 
                                                    for="customSwitch33"
                                                    v-html="(row.has_payment) ? 'Hide Payment' : 'Show Payment'">
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12 row" v-if="row.has_payment">
                                            <div class="form-group col-md-3 col-sm-12">
                                                <label>Payment Name (en)</label>
                                                <input type="text" 
                                                    class="form-control" 
                                                    v-model="row.payment_name">
                                            </div>
                                            <div class="form-group col-md-3 col-sm-12">
                                                <label>Payment Name (ar)</label>
                                                <input type="text" 
                                                    class="form-control" 
                                                    v-model="row.payment_name_ar">
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>Payment Link</label>
                                                <input type="text" 
                                                    class="form-control" 
                                                    v-model="row.payment_link">
                                            </div>
                                        </div>


                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch4" 
                                                    :checked="row.has_download"
                                                    @click="onDownload">
                                                <label class="custom-control-label" 
                                                    for="customSwitch4"
                                                    v-html="(row.has_download) 
                                                    ? 'Hide Download File' : 'Show Download File'">
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col-12 row" v-if="row.has_download">
                                            <div class="form-group col-3">
                                                <label>Download Title (en)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.download_name">
                                            </div>
                                            <div class="form-group col-3">
                                                <label>Download Title (ar)</label>
                                                <input type="text" class="form-control" 
                                                    v-model="row.download_name_ar">
                                            </div>
                                            <div class="form-group col-6">
                                                <label>Download File
                                                    <button v-if="row.download_preview" 
                                                        type="button" 
                                                        class="btn btn-danger btn-sm btn-pill"
                                                        style='margin-top: -10px; margin-left: 10px'
                                                        @click="row.download_preview = ''; 
                                                                row.download_file = ''">
                                                        Remove File
                                                    </button>
                                                </label>
                                                 <a v-if="row.download_preview" 
                                                        :href="row.download_preview" 
                                                        target="_blank" class="pull-right">Preview
                                                    </a>
                                                <input type="file" class="form-control" @change="onFileChange">
                                            </div>
                                            <div class="form-group col-md-6 col-sm-12">
                                                <label>Download Preview 180 * 220
                                                    <button v-if="row.download_image_preview" 
                                                        type="button" 
                                                        class="btn btn-danger btn-sm btn-pill"
                                                        style='margin-top: -10px; margin-left: 10px'
                                                        @click="row.download_image_preview = ''; 
                                                                row.download_image = ''">
                                                        Remove Image
                                                    </button>
                                                </label>
                                                <p>
                                                    <img v-if="row.download_image_preview" 
                                                        :src="row.download_image_preview"
                                                        style="max-width: 50%">
                                                </p>
                                                <input type="file" class="form-control" @change="onFilePreviewChange">
                                            </div>
                                        </div>

                                    </div>
                                </div>


                                    

                                </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Writer -->

                </div>
                <!-- ******* End Card ******** -->


                </div>
            </div>
            <!-- End Content -->


                <!-- Buttons -->
                <div class="col-md-12 row">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" :disabled="btnLoading">
                            <span v-if="btnLoading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading" class="ti-check-box"></span>
                            <span v-if="!btnLoading"> Create Product</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" class="btn btn-danger" 
                            :disabled="btnLoading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>
                <!-- End Buttons -->


                </form>
            </div>

                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            Editor
        },
        data(){
            return {
                auth: {
                    access_token: '',
                },
                row: {
                    status: 1,
                    view_in_home: 0,
                    has_faq: 0,
                    has_application: 0,
                    has_download: 0,
                    has_payment: 0,

                    faq_link: '',
                    payment_name: '',
                    payment_name_ar: '',
                    payment_link: '',
                    
                    download_name: '',
                    download_name_ar: '',
                    download_image_preview: '',
                    download_image: '',
                    download_preview: '',
                    download_file: '',

                    application_name: '',
                    application_name_ar: '',
                    application_path: 'members-applications',



                    preview: '',
                    image: '',
                    base64Image: '',
                    sort: 0,
                    subtitle: '',
                    subtitle_ar: '',
                    slug: '',
                    title: '',
                    title_ar: '',
                    bgTitle: '',
                    bgTitle_ar: '',
                    bgColor: '',
                    body: '',
                    body_ar: '',

                    title1: "Program Overview",
                    title2: "What You'll Learn",
                    title3: "Who Should Apply?",
                    title4: "Entry Requirements",
                    title5: "Price",

                    title1_ar: "نظرة عامة",
                    title2_ar: "ما سوف تتعلمه",
                    title3_ar: "من يجب ان يقدم",
                    title4_ar: "المتطلبات",
                    title5_ar: "السعر",

                    body1: '',
                    body2: '',
                    body3: '',
                    body4: '',
                    body5: '',
                    short_body: '',

                    body1_ar: '',
                    body2_ar: '',
                    body3_ar: '',
                    body4_ar: '',
                    body5_ar: '',
                    short_body_ar: '',

                },
                editor: {
                    api_key: 'xahz1dg338xnac8il0tkxph26xcaxqaewi3bd9cw9t4e6j7b',
                    menubar: 'file edit view insert format tools table tc help',
                    plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount'
                            ],
                    toolbar: 'undo redo | formatselect | bold italic backcolor | \
                              alignleft aligncenter alignright alignjustify | \
                              bullist numlist outdent indent | removeformat | help',
                },
                croppieImage: '',
                cropped: false,
                sector_id: this.$route.params.sector_id,
                btnLoading: false,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

        },
        methods: {
            
            // Add New
            addNew(){
                this.btnLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                const options = {
                    url: window.baseURL+'/products',
                    method: 'POST',
                    data: {
                        sector_id: this.sector_id,

                        status: this.row.status,
                        view_in_home: this.row.view_in_home,
                        has_faq: this.row.has_faq,
                        has_application: this.row.has_application,
                        has_download: this.row.has_download,
                        has_payment: this.row.has_payment,

                        faq_link: this.row.faq_link,
                        payment_name: this.row.payment_name,
                        payment_name_ar: this.row.payment_name_ar,
                        payment_link: this.row.payment_link,

                        download_name: this.row.download_name,
                        download_name_ar: this.row.download_name_ar,
                        download_image: this.row.download_image,
                        download_file: this.row.download_file,

                        application_name: this.row.application_name,
                        application_name_ar: this.row.application_name_ar,
                        application_path: this.row.application_path,

                        base64Image: this.row.base64Image,
                        sort: this.row.sort,
                        title: this.row.title,
                        title_ar: this.row.title_ar,
                        subtitle: this.row.subtitle,
                        subtitle_ar: this.row.subtitle_ar,
                        slug: this.row.slug,
                        bgTitle: this.row.bgTitle,
                        bgTitle_ar: this.row.bgTitle_ar,
                        bgColor: this.row.bgColor,
                        // body: this.row.body,

                        title1: this.row.title1,
                        title2: this.row.title2,
                        title3: this.row.title3,
                        title4: this.row.title4,
                        title5: this.row.title5,

                        title1_ar: this.row.title1_ar,
                        title2_ar: this.row.title2_ar,
                        title3_ar: this.row.title3_ar,
                        title4_ar: this.row.title4_ar,
                        title5_ar: this.row.title5_ar,

                        body1: this.row.body1,
                        body2: this.row.body2,
                        body3: this.row.body3,
                        body4: this.row.body4,
                        body5: this.row.body5,
                        short_body: this.row.short_body,

                        body1_ar: this.row.body1_ar,
                        body2_ar: this.row.body2_ar,
                        body3_ar: this.row.body3_ar,
                        body4_ar: this.row.body4_ar,
                        body5_ar: this.row.body5_ar,
                        short_body_ar: this.row.short_body_ar,
                    }
                }
                this.axios(options, config)
                    .then(() => {
                        this.btnLoading = false;
                        iziToast.success({
                            icon: 'ti-check',
                            title: 'Great job,',
                            message: 'Item Added Successfully.',
                        });
                        this.$router.push({ name: 'products', params:{sector_id: this.sector_id} })
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {})
            },


            // Title
            onTitleChange() {
                this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str){
                if(!str) {
                   let str = this.row.slug;
                   this.row.slug = str.replace(/\s+/g, '-')
                                      .replace(/\?+/g, '-')
                                      .replace(/\/+/g, '-')
                                      .replace(/\\+/g, '-');
                } else {
                    this.row.slug = str.replace(/\s+/g, '-')
                                      .replace(/\?+/g, '-')
                                      .replace(/\/+/g, '-')
                                      .replace(/\\+/g, '-');
                }
            },

            
              
            onImageChange(e){
                const file = e.target.files[0];
                this.row.preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.base64Image = e.target.result;
                };
            },

            onFileChange(e){
                const file = e.target.files[0];
                this.row.download_preview = URL.createObjectURL(file);
                this.createBase64File(file);
            },
            createBase64File(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.download_file = e.target.result;
                };
            },

            onFilePreviewChange(e){
                const file = e.target.files[0];
                this.row.download_image_preview = URL.createObjectURL(file);
                this.createBase64FilePreview(file);
            },
            createBase64FilePreview(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.download_image = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },
            onHome(){
                if(this.row.view_in_home)
                    this.row.view_in_home = 0;
                else
                    this.row.view_in_home = 1;
            },
            onFaq(){
                if(this.row.has_faq)
                    this.row.has_faq = 0;
                else
                    this.row.has_faq = 1;
            },
            onPayment(){
                if(this.row.has_payment)
                    this.row.has_payment = 0;
                else
                    this.row.has_payment = 1;
            },
            onApplication(){
                if(this.row.has_application)
                    this.row.has_application = 0;
                else
                    this.row.has_application = 1;
            },
            onDownload(){
                if(this.row.has_download)
                    this.row.has_download = 0;
                else
                    this.row.has_download = 1;
            },

            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: 'products', params:{sector_id: this.sector_id} });
                }
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
